// This shares a lot of code with MultiRunWorkspace, try to keep them
// in sync, or refactor
import React from 'react';

import {PanelBank} from '../../components/PanelBank/PanelBank';

interface RunPagePanelsProps {
  entityName: string;
  projectName: string;
  isProjectReadOnly: boolean;
  workspaceID?: string;
}

export const RunPagePanels = ({
  entityName,
  projectName,
  isProjectReadOnly,
  workspaceID,
}: RunPagePanelsProps) => {
  return (
    <div className="run-page-workspace">
      <PanelBank
        entityName={entityName}
        projectName={projectName}
        isProjectReadOnly={isProjectReadOnly}
        workspaceID={workspaceID}
      />
    </div>
  );
};
